import { render, staticRenderFns } from "./IntegrationPreview.vue?vue&type=template&id=2f88f134&scoped=true"
import script from "./IntegrationPreview.vue?vue&type=script&lang=js"
export * from "./IntegrationPreview.vue?vue&type=script&lang=js"
import style0 from "./IntegrationPreview.vue?vue&type=style&index=0&id=2f88f134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88f134",
  null
  
)

export default component.exports